import { motion } from "framer-motion";

/**
 * Editorial progress indicator.
 *  ┌──────────────────────────────────────────────────────┐
 *  │  STEP 01 / 05   ————————————————          Welcome     │
 *  └──────────────────────────────────────────────────────┘
 */
export default function ProgressIndicator({ current, total, label }) {
  const pct = Math.max(0, Math.min(1, (current - 1) / Math.max(1, total - 1)));
  return (
    <div
      className="w-full flex items-center gap-4 md:gap-8"
      data-testid="progress-indicator"
      data-current-step={current}
    >
      <div className="flex items-baseline gap-2 shrink-0">
        <span className="font-editorial text-2xl md:text-3xl leading-none text-[color:var(--sbh-terracotta)]">
          {String(current).padStart(2, "0")}
        </span>
        <span className="font-editorial text-lg md:text-xl italic text-[color:var(--sbh-muted)]">
          /
        </span>
        <span className="font-editorial text-lg md:text-xl text-[color:var(--sbh-muted)]">
          {String(total).padStart(2, "0")}
        </span>
      </div>
      <div className="progress-hairline flex-1">
        <motion.div
          className="fill"
          initial={false}
          animate={{ scaleX: pct }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        />
      </div>
      {label && (
        <div className="hidden md:block eyebrow text-[color:var(--sbh-ink-2)] shrink-0">
          {label}
        </div>
      )}
    </div>
  );
}
